module.exports = __webpack_public_path__ + "static/img/etek-js.c243768.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/etek-js.png
// module id = CPyK
// module chunks = 1